// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2099":"189a04b9","9668":"189a04b9"}[chunkId] + ".chunk.css";
};